<script setup lang="ts">
import { useSpace } from "@/api/space-query";
import { useStation } from "@/api/station-query";
import { mdiArrowRight } from "@mdi/js";
import { Badge, Icon } from "@soft-db/ui";
import { icRemoteOutline, icWorkspacesOutline } from "../icons";

const props = defineProps<{
	stationId: string;
	useStationSpace?: boolean;
	spaceId?: string | null;
}>();

const { t } = useI18n();

const { station } = useStation(() => props.stationId);

const hasSpace = computed(() =>
	props.useStationSpace ? station.value?.space != null : props.spaceId !== ""
);

const { space } = useSpace(() =>
	props.useStationSpace ? station.value?.space || "" : props.spaceId || ""
);
</script>

<template>
	<div v-if="station" class="flex items-center gap-2">
		<Badge class="truncate" color="primary" size="sm">
			<Icon :d="icRemoteOutline" size="sm" />
			{{ station.name }}
		</Badge>
		<Icon :d="mdiArrowRight" size="sm" />
		<Badge class="truncate" :color="hasSpace ? 'primary' : 'warning'" size="sm">
			<Icon :d="icWorkspacesOutline" size="sm" />
			{{ hasSpace ? space?.name : t("space.noSpace") }}
		</Badge>
	</div>
</template>
